/**
 * Modulo que encapsula los formateadores de fechas humanizadas (en texto).
 */

import { DATEFORMATS_HUMANIZED } from './DATEFORMATS_HUMANIZED';
import { onBeforeFormat } from './src/onBeforeFormat';

/**
 * Objeto `humanizer` es el "state" que va almacenar las funciones de formateo por locale.
 * Si se cambia la locale, se crearan nuevas funciónes.
 */
const humanizer = {
  currentLocaleId: null,
  // Ejemplo:
  // es: {
  //   datetime: new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED['datetime']).format,
  //   datetimelong: new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED['datetimelong']).format,
  //   date: new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED['date']).format,
  //   time: new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED['time']).format,
  //   timelong: new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED['timelong']).format,
  // }
};

/**
 * Devuelve la fecha humanizada en el tipo seleccionado.
 * Tomando en cuenta el timezone.
 *
 * @param {Object} state
 * @param {Date} value la fecha a formatear
 * @param {string} type el tipo datetime|datetimelong|date|time|timelong
 * @returns {string}
 */
export function humanizeFn(state, value, type) {
  try {
    const currentDate = onBeforeFormat(value);

    // creamos la función de formateo, ej: `humanizer['en-US'].datetimelong(new Date())`
    humanizer[state.id] = humanizer[state.id] || {};
    if (!humanizer[state.id][type]) {
      humanizer[state.id][type] = new Intl.DateTimeFormat(state.id, DATEFORMATS_HUMANIZED[type]).format;
    }

    // aplica el formateo
    return humanizer[state.id][type](currentDate);
  } catch (e) {
    console.error(e);
    return '';
  }
}
